import React from 'react'

export default {
  forSale: true,
  canView: true,
  title: 'Áfangi B',
  key: 'afangi-b',
  rect: {
    className: 'bg-primary text-white',
    props: {
      x: 2700,
      y: 1670,
      width: 420,
      height: 160,
    },
  },
  path: {
    d: 'm4493.7 2144.6-208.63 8.11h-309l-345.21-60-432.81-79.12-100.34-18.05-340.28-60.11-232.07-42.43-101.9-17.04-34.07-8.03-125.03-32.14-198.65-50.79-198.32-50.79-116.68-40.82-100.5-34.39-6-3 93.43-13.5.54-11.41 29.46-5.39 148.37-29.86 29.97 15.51 16.07-2.9-.24-17.35 31.34-17.36 29.25 3.3 48.08 9.16-.32-19.45 27.27-15.54 106.98 17.31 58.34-9.48.72-18 102.89-21 31.5-1.93-.11 26.46 53.46 8.89 2.9.43-15 3.22 38.92 6.27-.65-19.37 20.82-8.04 22.42-.48 60.91 9.96 7.79-.72.64-22.98 85.83-19.39 36.21-4.5 37.39 15.75.11 19.6 10.07.11 47.79-11.89 37.18-3.43 40.07 15.43-.32 18.75 14.57 1.82 46.28-11.57 41.15-4.07 41.03 15.85v21.11l16.07 2.47 47.36-13.83 43.07-4.28 41.89 16.28.54 21.86 22.23 3 42.91-13.18 46.18-4.07 44.98 17.25v21.38l26.43 3.61 44.47-14.81 46.55-3.86 47.14 18.11.54 22.39 51.11 6.75 52.07 7.5 40.34-15.26 50.14-3.38 50.46 18.32.33 23.31 61.87 9.32 33.86-14.31 47.89-4.18 48.64 18.43-1.18 19.18 46.5 7.61 28.24 39.8 11.73 19.61 8.68 10.12 2.91 1.47-.02 4.08 4.4 5.48 11.35 15.92 106.39 108.38 6.91 3.69 41.07 1.37-1.13 25.55 58.58 39.7 33.75 2.65 47.17 28.29-.8 22.01 49.26 5.39 49.98 29.65-.64 24.43 56.16 36.08z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/floahverfid/afangi-b.jpg'),
      width: 3840,
      height: 2160,
    },
    list: [
      {
        lod: 'floatetur-fifusund-1',
        d: 'M347.44 1016.13h0l-93.58 152.51-.38.6 337.82-1.94 43.62-152.11h0l-287.48.94z',
      },
      {
        lod: 'floatetur-fifusund-2',
        d: 'M1013.48 989.86h0l32.65-164-280.29 3.19-43.7 162.61h0l291.34-1.8z',
      },
      {
        lod: 'floatetur-fifusund-3',
        d: 'M657.14 853.43H447.36l-6.43 11.78h-8.36l-20.78 33.65-3.43 18-60.92 99.27h0l287.48-.94h0l41.29-143.98-19.07-17.78z',
      },
      {
        lod: 'floatetur-fifusund-4',
        d: 'M1030.08 683.52H803.56h0L773.93 793l232.6-.64 23.55-108.84h0z',
      },
      {
        lod: 'floatetur-fifusund-5',
        d: 'M760.21 581.71l-57.05 196.72-29.09 18.48H482.02l120.05-187.23 4.9-14.68h3.94l8.68-13.9h140.8l-.18.61z',
      },
      {
        lod: 'gardafloi-1',
        d: 'M3127.04 784.98l-226.99-187.03-2.82-7.11-7.31-1.05-18.99-16-125.3-.04h0l48.1 213.36h0l333.31-1.14v-.99z',
      },
      {
        lod: 'gardafloi-2',
        d: 'M2727.84 440.69l-112.02-104.71-189.86.2 28.24 188.31h0l170.54-.39 103.1-83.41z',
      },
      {
        lod: 'gardafloi-3',
        d: 'M2745.63 573.75l-239.74-.06h0l35.25 214.28h0l252.59-.86-48.1-213.36z',
      },
      {
        lod: 'gardafloi-4',
        d: 'M2425.96 336.18l-62.62.07-40.7-6.78-45.52 7.32-77.31.2 16.21 188.05 238.18-.55h0l-28.24-188.31z',
      },
      {
        lod: 'gardafloi-5',
        d: 'M2294.95 679.63l2.14-14.63 184.91.29 1.29 13.82h39.95l-17.35-105.42-41.14-.01-.8-3.8-179.9-.65-.48 5.84h-40.39l-20.25 16.07 7.58 88.59.48.36 63.96-.46z',
      },
      {
        lod: 'gardafloi-6',
        d: 'M2131.32 337l-64.18.32-36.96-6.32-32.14 5.46-71.68.25 2.25 174.42h0l13.39-.08.11 15 203.14-.48L2131.32 337z',
      },
      {
        lod: 'gardafloi-7',
        d: 'M1965.09 667.43l139.58.67.72 11.99h50.78l-6.21-88.73-24.16-16.4h-26.67l-.33-4.5-136.01.43-.11 5.15-33.32.1 1.44 104.45 34.29-.79v-12.37z',
      },
      {
        lod: 'gardafloi-8',
        d: 'M1926.36 336.71l-68.57.24-36.54-5.9-35.68 6.26-65.09.3-7.87 189.16 201.53-.5.06-15.06 14.41-.08h0l-2.25-174.42z',
      },
      {
        lod: 'gardafloi-9',
        d: 'M1929.36 576.14l-103.5.32-8.36-.64-6.75.22-100.72.46h0l-8.91 213.94 231.19-.72-2.95-213.58z',
      },
      {
        lod: 'gardafloi-10',
        d: 'M1720.48 337.61l-66 .3-43.66-7.39-39.13 7.36-56.18.19-18.9 189.23 216-.53 7.87-189.16h0z',
      },
      {
        lod: 'gardafloi-11',
        d: 'M1710.03 576.5l-102.61.47-13.98-1.93-13.74 1.93-88.24.43h0l-22.01 213.68 231.67-.64 8.91-213.94z',
      },
      {
        lod: 'gardafloi-12',
        d: 'M1443.29 338.31l-40.35-6.43-37.96 6.94-55.12.09h0l-30 188.93 216.75-.54 18.9-189.23-72.22.24z',
      },
      {
        lod: 'gardafloi-13',
        d: 'M1491.46 577.4l-114.18.56-6.03.11-7.93-.05-90.83-.07-33.99 213.77 230.95-.64 22.01-213.68z',
      },
      {
        lod: 'gardafloi-14',
        d: 'M1309.86 338.91l-84.86.13-33.11-4.83-28.18 4.93-59.57.22-40.5 189.02 216.22-.54 30-188.93h0z',
      },
      {
        lod: 'gardafloi-15',
        d: 'M1272.49 577.95l-124.42-.09-95.19.32-46.35 214.18 231.97-.64 33.99-213.77z',
      },
      {
        lod: 'gardafloi-16',
        d: 'M1104.14 339.36l-85.58.32-33.99-5.47-31.1 5.31H897.3l-51.46 189.4 217.8-.54h0l40.5-189.02z',
      },
      {
        lod: 'gardafloi-17',
        d: 'M1030.08 683.52h0l22.8-105.34-45.89.16-3.21-8.76-136.13-.64-3.37 10.04h-10.93l-25.96 16.48-23.83 88.06h226.52z',
      },
      {
        lod: 'laekjarfloi-1',
        d: 'M2970.03 1221.83l78.76 325.78 2.17 1.45 237.95-24.71 235.99-24.51-87-251.86-43.94-27.95-194.96.83-228.97.97z',
      },
      {
        lod: 'laekjarfloi-2',
        d: 'M3746.45 1181.98l1.71-3.05-83.89-52.29-3.22 3.54-37.68-23.03-100.07 119.76 88.58 56.11 11.89 7.93 16.23 10.07 17.14 10.98 16.02 10.13 17.84 11.03 96.51-125.95-41.06-25.23z',
      },
      {
        lod: 'laekjarfloi-4',
        d: 'M3580.47 1080.93l1.12-2.41-81.44-49.3-1.28 2.01-.97-.56-41.86-25.39-91.18 146.01-.58.99 9.26-.03 5.67.54 14.58 2.46 9.53 2.25 11.04 3.86 11.68 4.82 36.75 22.39 60.51 38.34 100.07-119.76-42.9-26.22z',
      },
      {
        lod: 'laekjarfloi-5',
        d: 'M3048.79 1547.61l-78.76-325.78-159.1.67 71.03 342.46 1.55 1.49 167.45-17.39-2.17-1.45z',
      },
      {
        lod: 'laekjarfloi-6',
        d: 'M3339.97 928.91l-.13-5.84-9.11-.4-122.95-81.64h0l-10.49 311.69 166.99-.44.58-.99 91.18-146.01-116.07-76.37z',
      },
      {
        lod: 'laekjarfloi-7',
        d: 'M2729.77 1396.14l1.93-4.91 50.14 4.91h65.11l-36.02-173.64-135 .57-23.14 21.64 26.61 152.19h0l50.37-.76z',
      },
      {
        lod: 'laekjarfloi-8',
        d: 'M3203.86 957.35l-171.31.45h0l53.2 195.22 111.54-.3 6.57-195.37z',
      },
      {
        lod: 'laekjarfloi-9',
        d: 'M2590 1397.29l-23.28-151.18-28.52-22.1-160.13 1.04h0l19.33 173.26h0l192.6-1.02z',
      },
      {
        lod: 'laekjarfloi-10',
        d: 'M2920.1 1048h137.03l28.62 105.02-132.11.36-12.29-20.02-21.25-85.36z',
      },
      {
        lod: 'laekjarfloi-10a',
        d: 'M2897.93 956.93l134.62.87 24.58 90.2H2920.1l-22.17-91.07z',
      },
      {
        lod: 'laekjarfloi-11',
        d: 'M2378.07 1225.05h0l-183.75 1.19h0l28.26 408.83 198.93-20.61-43.44-389.41z',
      },
      {
        lod: 'laekjarfloi-12',
        d: 'M2957.34 951.84l40.93 6.05 205.59-.54h0l3.92-116.32h0l-34.79-23.09-325.42 1.09 24.75 105.33H2890l7.93 32.57 56.95.05 2.46-5.14z',
      },
      {
        lod: 'laekjarfloi-13',
        d: 'M2194.32 1226.24h0l-243.69 1.59h0l7.09 434.68h0l264.86-27.44-28.26-408.83z',
      },
      {
        lod: 'laekjarfloi-14',
        d: 'M2872.32 924.36l-24.75-105.33-301.66 1.01h0l22.51 138.12 53.35-.62 1.77-4.9 37.84 5.55 104.12-.83 2.36-4.72 38.78 5.25 48.71-.62-7.62-32.91h24.59z',
      },
      {
        lod: 'laekjarfloi-15',
        d: 'M1957.72 1662.51h0l-7.09-434.68h0l-243.01 1.57h0l-17.41 460.81h0l267.51-27.7z',
      },
      {
        lod: 'laekjarfloi-16',
        d: 'M2863.86 1134.14l32.46.22-40.97-177.09-48.71.62-38.78-5.25-2.36 4.72-54 .43 38.14 195.59 1.15 1.06 117.25-.48-4.18-19.82z',
      },
      {
        lod: 'laekjarfloi-17',
        d: 'M1464.47 1230.98h0l-40.82 442.24 266.56 16.99 17.41-460.81h0l-243.15 1.58z',
      },
      {
        lod: 'laekjarfloi-18',
        d: 'M2711.5 957.79l-50.12.4-37.84-5.55-1.77 4.9-53.35.62 32.08 196.89 150.29-.61-1.15-1.06-38.14-195.59z',
      },
      {
        lod: 'laekjarfloi-19',
        d: 'M1221.25 1232.56h0l-62.15 423.79h0l264.55 16.87 40.82-442.24h0l-243.22 1.58z',
      },
      {
        lod: 'laekjarfloi-20',
        d: 'M2568.42 958.16l-58.67.67-49.18-5.7-1.52 5.7-46.37.1 25 196.78 162.82-.66-32.08-196.89z',
      },
      {
        lod: 'laekjarfloi-21',
        d: 'M977.34 1234.15h0l-81.02 405.44 262.78 16.76 62.15-423.79h0l-243.91 1.59z',
      },
      {
        lod: 'laekjarfloi-22',
        d: 'M2349.08 959.07l-49.38-5.14-.53 4.82-43.85.16 15.69 176.06 28.61 21.3 138.06-.56-25-196.78-63.6.14z',
      },
      {
        lod: 'laekjarfloi-23',
        d: 'M734.07 1235.73h0l-99 387.2 261.25 16.66 81.02-405.44h0l-243.27 1.58z',
      },
      {
        lod: 'laekjarfloi-24',
        d: 'M2177.71 982.83l-291.31.67.43 175.49 277.3-1.92 24.73-21.11-11.15-153.13h0z',
      },
      {
        lod: 'laekjarfloi-25',
        d: 'M571.38 1236.79l-81.49 1.52-103.67 335.38 248.85 49.24 99-387.2h0l-162.69 1.06z',
      },
      {
        lod: 'laekjarfloi-26',
        d: 'M1886.02 822.62h0l-60.16.17-.22-1.4-83.62-9-81.86 8.79-.11 1.77-53.62.4-21.64 337.74 302.04-2.1h0l-.81-336.37z',
      },
      {
        lod: 'laekjarfloi-27',
        d: 'M43.21 1505.82l343.01 67.87 103.67-335.38 81.49-1.52 19.92-69.49-337.82 1.94-210.27 336.58z',
      },
      {
        lod: 'laekjarfloi-28',
        d: 'M1523.61 823.96l-67.93-7.82-64.18 8.09-64.71.39-42.06 318.15.05.21h16.02l-2.57 20.09 286.56-1.98 21.64-337.74-82.82.61z',
      },
      {
        lod: 'laekjarfloi-30',
        d: 'M1326.79 824.62h0l-95.44.58-63.89-7.32-63.24 7.32-58.09.66-67.34 338.28-.79.91 287.34-1.98 2.62-20.09h16.82l-.05-.21 42.06-318.15z',
      },
      {
        lod: 'laekjarfloi-32',
        d: 'M1013.48 989.86l-291.34 1.8h0l-41.56 154.64 19.41 20.65 278.01-1.9.79-.91 34.69-174.28h0z',
      },
      {
        lod: 'nesfloi-1',
        d: 'M2620.11 1593.89l-30.11-196.6-192.6 1.02h0l24.11 216.15 198.6-20.57z',
      },
      {
        lod: 'nesfloi-2',
        d: 'M2883.51 1566.45l-1.55-1.49-35.01-168.82h-65.11l-50.14-4.91-1.93 4.91-50.37.76h0l32.77 187.35 171.34-17.8z',
      },
      {
        lod: 'tjarnarfloi-1',
        d: 'M2177.71 982.83l-11.73-161.01-279.96.8h0l.38 160.88 291.31-.67h0z',
      },
      {
        lod: 'tjarnarfloi-2',
        d: 'M2545.91 820.04l-302.86 1.02 12.27 137.85 43.85-.16.53-4.82 49.38 5.14 109.97-.24 1.52-5.7 49.18 5.7 58.67-.67-22.51-138.12h0z',
      },
      {
        lod: 'tjarnarfloi-3',
        d: 'M2156.17 680.09h-50.78l-.72-11.99-139.58-.67v12.37l-34.29.79 1.51 109.13 231.48-.72-7.62-108.91h0z',
      },
      {
        lod: 'tjarnarfloi-4',
        d: 'M2523.24 679.11h-39.95l-1.29-13.82-184.91-.29-2.14 14.63-63.96.46-.48-.36 9.36 109.27 301.27-1.03h0l-17.9-108.86h0z',
      },
    ],
  },
}
